var app = angular.module('app')
    .filter('htmlEscape', htmlEscape);
htmlEscape.$inject = ['$sce'];
function htmlEscape ($sce) {
    return function(input) {
        return $sce.trustAsHtml(input);
    }
}